import { render, staticRenderFns } from "./ModelDetail.vue?vue&type=template&id=96871b7e&scoped=true&"
import script from "./ModelDetail.vue?vue&type=script&lang=js&"
export * from "./ModelDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModelDetail.vue?vue&type=style&index=0&id=96871b7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96871b7e",
  null
  
)

export default component.exports